export const faqHome = [
	{
		question: 'Tu travailles avec quel type de clients ?',
		answer:
			"Je travaille avec des startups, des entrepreneurs solo et des PME qui veulent lancer ou scaler un produit digital. Mon coeur de cible : les fondateurs non-tech qui ont une idée solide mais besoin d'un partenaire technique de confiance."
	},
	{
		question: 'Combien coûte un projet de développement ?',
		answer:
			'Chaque projet est unique. Le meilleur point de départ est le diagnostic gratuit de 30 minutes — on définit ensemble le périmètre et je te donne une estimation claire sans engagement.'
	},
	{
		question: 'Tu es basé où et tu travailles en remote ?',
		answer:
			"Je suis basé à Abidjan (Côte d'Ivoire) et je travaille avec des clients partout en Afrique et en Europe, 100% remote. Les fuseaux horaires ne sont jamais un problème."
	},
	{
		question: "C'est quoi la méthode IMPACT ?",
		answer:
			"IMPACT est mon framework en 6 étapes : Identifier, Modéliser, Prototyper, Automatiser, Construire, Transformer. Il permet de passer de l'idée à un produit rentable en 90 jours maximum, en évitant les erreurs classiques qui font perdre du temps et de l'argent."
	},
	{
		question: 'Tu peux reprendre un projet existant ?',
		answer:
			'Oui. Audit de code, refactoring, ajout de features, migration technique — je peux intervenir sur un projet en cours. Un audit technique préalable permet de définir la meilleure approche.'
	}
];

export const faqSolutions = [
	{
		question: 'Quels sont tes délais de livraison ?',
		answer:
			'Un MVP complet : 4 à 12 semaines selon la complexité. Une feature spécifique : 1 à 3 semaines. Un audit technique : 48h. Je livre par sprints de 2 semaines avec démos régulières — pas de surprise après 6 mois.'
	},
	{
		question: 'Quelle stack technique tu utilises ?',
		answer:
			"SvelteKit, TypeScript, PostgreSQL (NeonDB), Drizzle ORM, Tailwind CSS pour le frontend/fullstack. Pour les APIs et l'IA : Node.js, Python, OpenAI/Anthropic. Je choisis toujours la stack la plus adaptée à ton projet."
	},
	{
		question: 'Tu fais aussi le design ou uniquement le code ?',
		answer:
			"Je conçois et développe. Je travaille avec Figma pour les maquettes et je peux partir de zéro ou d'un design existant. Pour des projets avec des besoins design avancés, je collabore avec des designers partenaires."
	},
	{
		question: "Qu'est-ce qui se passe après la livraison ?",
		answer:
			'Je propose un suivi post-livraison de 30 jours inclus sur tous les projets. Au-delà, des contrats de maintenance mensuelle sont disponibles. Tu ne te retrouves jamais seul face à un bug en prod.'
	},
	{
		question: 'Comment se déroule le diagnostic gratuit ?',
		answer:
			"30 minutes en visio. On analyse ton projet, identifie les blocages, et je te donne un plan d'action concret en 3 étapes. Zéro engagement, zéro pitch commercial. Si on travaille ensemble après, c'est ton choix."
	}
];

export const faqAcademy = [
	{
		question: 'Les formations sont pour quel niveau ?',
		answer:
			"J'ai du contenu pour tous les niveaux. Les débutants apprennent les bases du développement web et de l'entrepreneuriat tech. Les intermédiaires avancent sur SvelteKit, les APIs et les bonnes pratiques. Les avancés travaillent sur l'architecture, la scalabilité et le lancement produit."
	},
	{
		question: "C'est quoi le bootcamp intensif ?",
		answer:
			'3 jours en live pour maîtriser SvelteKit et lancer un premier projet fonctionnel. Petit groupe (max 10 personnes), beaucoup de pratique, zéro théorie inutile. Tu repars avec un projet réel dans ton portfolio.'
	},
	{
		question: 'Le mentorat 1-to-1, comment ça fonctionne ?',
		answer:
			"4 sessions privées de 1h en visio, espacées sur 4 semaines. On travaille sur ton projet spécifique : roadmap, choix techniques, déblocage, code review. C'est du sur-mesure total — pas un cours générique."
	},
	{
		question: 'Tu as formé combien de personnes ?',
		answer:
			"200+ personnes depuis 2018. Des profils variés : développeurs juniors, entrepreneurs, reconversions professionnelles. Certains travaillent maintenant dans des startups tech, d'autres ont lancé leurs propres produits."
	},
	{
		question: 'Les formations sont en français ou en anglais ?',
		answer:
			"Principalement en français pour toucher le maximum d'apprenants en Afrique francophone et en Europe. Certains contenus avancés sont disponibles en anglais."
	}
];

export const faqAbout = [
	{
		question: 'Quel est ton parcours professionnel ?',
		answer:
			"10 ans d'expérience dans le développement web et le conseil produit. J'ai démarré comme développeur freelance en 2018, travaillé sur plusieurs projets, mentoré 200+ personnes en collaboration avec des établissements comme Ivoire Geek School, et formalisé la méthode IMPACT en 2024 après avoir identifié les patterns qui fonctionnent sur 10+ projets."
	},
	{
		question: 'Tu es freelance ou tu as une équipe ?',
		answer:
			'Je travaille principalement en solo ce qui garantit une communication directe et zéro intermédiaire. Pour les projets plus larges, je collabore avec un réseau de développeurs et designers de confiance selon les besoins.'
	},
	{
		question: 'Tu travailles uniquement avec des clients africains ?',
		answer:
			'Non — ma clientèle est internationale. Abidjan est ma base, mais je travaille avec des clients en France, Belgique, Canada et partout en Afrique. Le remote est mon mode de travail par défaut depuis 2018.'
	},
	{
		question: 'Comment puis-je te contacter ?',
		answer:
			'Via le formulaire de contact ou en réservant directement un diagnostic gratuit de 30 minutes. Je réponds sous 24h maximum en jours ouvrés.'
	}
];

export const faqProjects = [
	{
		question: 'Tu peux partager les métriques de tes projets ?',
		answer:
			'Sur les projets publics, oui. Sur les projets clients sous NDA, je partage les métriques en anonymisant les données sensibles. Lors du diagnostic, je peux aller plus dans le détail selon ton secteur.'
	},
	{
		question: 'Tu peux réaliser un projet similaire au mien ?',
		answer:
			"La meilleure façon de le savoir est le diagnostic gratuit de 30 minutes. Je t'y présente des projets similaires à ton cas et on évalue ensemble la faisabilité et les délais."
	},
	{
		question: 'Tes projets sont-ils open source ?',
		answer:
			"Certains outils et side-projects sont open source sur mon GitHub. Les projets clients sont propriétaires. Tu gardes 100% de la propriété intellectuelle de ce qu'on construit ensemble."
	},
	{
		question: 'Tu as des références dans mon secteur ?',
		answer:
			"J'ai travaillé dans la fintech, l'edtech, le e-commerce et les SaaS B2B. Contacte-moi en précisant ton secteur et je te mettrai en relation avec des clients qui ont accepté d'être référents."
	}
];

export const faqBlog = [
	{
		question: 'À quelle fréquence tu publies des articles ?',
		answer:
			'Deux articles par mois minimum — un article technique et un article stratégie produit/entrepreneuriat. Je préfère la qualité à la quantité : chaque article est actionnable et basé sur des expériences réelles.'
	},
	{
		question: 'Comment être notifié des nouveaux articles ?',
		answer:
			"Inscris-toi à la newsletter depuis le bas de page. Tu reçois chaque nouvel article directement dans ta boîte mail, plus le guide gratuit 'Les 7 erreurs qui tuent un produit digital' en cadeau de bienvenue."
	},
	{
		question: 'Tu acceptes des articles invités ?',
		answer:
			'Oui, sous conditions. Le contenu doit être original, technique ou stratégique, et apporter une vraie valeur aux lecteurs. Contacte-moi avec ton sujet et un plan avant de rédiger.'
	},
	{
		question: 'Puis-je republier tes articles ?',
		answer:
			"Avec attribution et lien vers l'original, oui. Pour une republication commerciale ou une traduction, contacte-moi d'abord."
	}
];
export const faqGeneral = [
	{
		id: 'general',
		icon: '🌐',
		title: 'Général',
		questions: [
			{
				q: 'Qui est derrière juslin.dev ?',
				a: "Je suis Juslin, Product Engineer & Digital Architect. J'accompagne des entrepreneurs, startups et structures qui veulent transformer leurs idées en produits digitaux performants — avec une expertise centrée sur SvelteKit, TypeScript et les technologies modernes du web."
			},
			{
				q: "À qui s'adressent vos services et produits ?",
				a: "Mes services s'adressent aux entrepreneurs, PME et organisations qui veulent un site web professionnel ou une application sur mesure. Mes produits éducatifs (livre, guides) ciblent principalement les étudiants et jeunes professionnels francophones, notamment en Afrique."
			},
			{
				q: 'Êtes-vous disponible pour des projets internationaux ?',
				a: 'Oui, je travaille avec des clients partout dans le monde. Les collaborations se font principalement en ligne via des outils comme Notion, Figma et les plateformes de visioconférence.'
			}
		]
	},
	{
		id: 'services',
		icon: '🛠️',
		title: 'Services & Prestations',
		questions: [
			{
				q: 'Quels types de projets prenez-vous en charge ?',
				a: "Je conçois et développe des sites vitrine, landing pages, applications web SaaS, systèmes de gestion (ERP/CRM), et plateformes e-learning. Chaque projet est traité de la conception UX/UI jusqu'au déploiement en production."
			},
			{
				q: 'Quelles technologies utilisez-vous ?',
				a: "Mon stack principal est SvelteKit + TypeScript + Tailwind CSS côté frontend, avec NeonDB (PostgreSQL), Drizzle ORM et des APIs REST côté backend. Pour les apps desktop, j'utilise Tauri."
			},
			{
				q: 'Proposez-vous de la maintenance après livraison ?',
				a: 'Oui. Des forfaits de maintenance mensuelle sont disponibles pour assurer les mises à jour, corrections de bugs, et évolutions mineures de votre projet.'
			},
			{
				q: 'Combien de temps dure un projet en moyenne ?',
				a: 'Cela dépend de la complexité. Un site vitrine peut être livré en 1 à 2 semaines, une application complète prend généralement 4 à 12 semaines selon les fonctionnalités.'
			}
		]
	},
	{
		id: 'tarifs',
		icon: '💰',
		title: 'Tarifs & Paiement',
		questions: [
			{
				q: 'Comment fonctionne votre système de devis ?',
				a: 'Vous pouvez demander un devis directement via le formulaire sur le site. Je vous réponds sous 24h avec une estimation détaillée selon vos besoins. Les devis sont gratuits et sans engagement.'
			},
			{
				q: 'Quels sont les modes de paiement acceptés ?',
				a: "J'accepte les virements bancaires, les paiements Mobile Money (pour l'Afrique francophone), et PayPal pour les clients internationaux."
			},
			{
				q: 'Y a-t-il un acompte au démarrage ?',
				a: 'Oui, un acompte de 50% est demandé au lancement du projet. Le solde est réglé à la livraison finale validée par le client.'
			},
			{
				q: 'Les produits du Mouvement 1000 F sont-ils vraiment à 1000 FCFA ?',
				a: "Absolument. Le Mouvement 1000 F est une initiative pensée pour rendre la connaissance en IA accessible à tous les étudiants d'Afrique francophone. Les produits numériques de cette gamme sont fixés à 1000 FCFA."
			}
		]
	},
	{
		id: 'produits',
		icon: '📚',
		title: 'Produits Digitaux',
		questions: [
			{
				q: "C'est quoi le livre 'Parler le langage de l'IA' ?",
				a: "'Parler le langage de l'IA' est un guide pratique pour apprendre à communiquer efficacement avec les outils d'intelligence artificielle grâce au prompt engineering. Il est rédigé en français et conçu pour les débutants comme pour les intermédiaires."
			},
			{
				q: 'Comment recevoir le livre après achat ?',
				a: "Le livre est livré immédiatement en format numérique (PDF) par email après confirmation de paiement. Aucun délai d'attente."
			},
			{
				q: 'Y a-t-il une garantie de remboursement ?',
				a: 'Oui, une garantie satisfait-ou-remboursé de 7 jours est offerte sur les produits numériques. Si le produit ne correspond pas à vos attentes, contactez-moi par email.'
			},
			{
				q: 'Comment rejoindre le Mouvement 1000 F ?',
				a: "Inscrivez-vous à la newsletter sur la page d'accueil pour être informé des sorties de nouveaux produits. La communauté grandit autour d'une vision commune : démocratiser l'accès à l'IA en Afrique."
			}
		]
	},
	{
		id: 'collaboration',
		icon: '🤝',
		title: 'Collaboration & Process',
		questions: [
			{
				q: 'Comment se déroule une collaboration avec vous ?',
				a: 'Le process suit 4 étapes : (1) Échange de découverte et devis, (2) Signature de contrat et acompte, (3) Développement itératif avec points réguliers, (4) Tests, validation et livraison. Vous êtes impliqué à chaque étape.'
			},
			{
				q: "Puis-je suivre l'avancement de mon projet ?",
				a: "Oui. Un espace de suivi partagé (Notion ou autre outil selon votre préférence) est mis en place pour que vous voyiez l'avancement en temps réel et puissiez donner vos retours facilement."
			},
			{
				q: 'Que se passe-t-il si je souhaite modifier le périmètre en cours de projet ?',
				a: 'Les modifications mineures sont intégrées sans frais supplémentaires. Pour des ajouts significatifs de fonctionnalités, un avenant au contrat est établi avec un nouveau devis.'
			}
		]
	}
];

export const faqCaseStudies = [
	{
		question: 'Travaillez-vous avec des clients en dehors de la Côte d\'Ivoire ?',
		answer: 'Oui, j\'accompagne des clients dans toute l\'Afrique francophone et en Europe.'
	},
	{
		question: 'Comment se déroule un projet type ?',
		answer: 'Diagnostic → Proposition → Développement itératif → Livraison → Suivi.'
	},
	{
		question: 'Quels types de projets acceptez-vous ?',
		answer: 'SaaS, applications web, plateformes digitales, audits et consulting.'
	}
];